
export class Keys {
    static readonly BACKSPACE = "Backspace";
    static readonly ENTER = "Enter";
    static readonly TAB = "Tab";
    static readonly ESC = "Escape";
    static readonly SPACE = " ";
    static readonly PAGEUP = "PageUp";
    static readonly PAGEDOWN = "PageDown";
    static readonly END = "End";
    static readonly HOME = "Home";
    static readonly LEFT = "ArrowLeft";
    static readonly UP = "ArrowUp";
    static readonly RIGHT = "ArrowRight";
    static readonly DOWN = "ArrowDown";
    static readonly DELETE = "Delete";
    static readonly KEY_0 = "0";
    static readonly KEY_1 = "1";
    static readonly KEY_2 = "2";
    static readonly KEY_3 = "3";
    static readonly KEY_4 = "4";
    static readonly KEY_5 = "5";
    static readonly KEY_6 = "6";
    static readonly KEY_7 = "7";
    static readonly KEY_8 = "8";
    static readonly KEY_9 = "9";
    static readonly F5 = "F5";
    static readonly PERIOD = ".";
}

export class KeySets {
    static readonly NUMBERS = [
        Keys.KEY_0,
        Keys.KEY_1,
        Keys.KEY_2,
        Keys.KEY_3,
        Keys.KEY_4,
        Keys.KEY_5,
        Keys.KEY_6,
        Keys.KEY_7,
        Keys.KEY_8,
        Keys.KEY_9,
    ];

    // FUTURE: This set of keys isn't really very encompassing, and probably
    //  shouldn't be generally used and called non-input-keys. Each
    //  user of it probably needs their own version specific to their
    //  use case.
    static readonly NON_INPUT_KEYS = [
        Keys.BACKSPACE,
        Keys.DELETE,
        Keys.ENTER,
        Keys.TAB,
        Keys.UP,
        Keys.DOWN,
        Keys.RIGHT,
        Keys.LEFT,
        Keys.F5
    ];
}
